import * as a from "redux/actions/action_types";

const invoiceDownload = (state, action) => {
    if (state === undefined) {
      state = null;
    }
    switch (action.type) {
      case a.INVOICE_DOWNLOAD:
        return action.payload;
  
      default:
        return state;
    }
  };
  
  export default invoiceDownload;